import React from "react";
import { Link } from "react-router-dom";
import { dishes } from "../data/dishes";
import { eventKinds, eventsIntro, eventGallery } from "../data/events";
import { useTheme, useDocumentTitle, useSite } from "../hooks/useSite";
import SpeechBubble from "../components/SpeechBubble";
import { Guest } from "../illustrations";

export default function EventsPage() {
  useTheme(dishes[0]);
  useDocumentTitle("Celebrations");
  const { openModal } = useSite();
  return (
    <>
      <section className="ro-faq-intro ro-events-intro">
        <div className="ro-container ro-split ro-faq-intro__split">
          <div>
            <h1>
              <strong className="ro-italic">Memorable</strong>
              <br />
              <span className="ro-outline ro-outline--light">Celebrations</span>
            </h1>
            <p>We will make your happiness into a double dose with our celebrations. Let’s celebrate your events in the joyful environment at RollOver.</p>
            <p>{eventsIntro}</p>
            <Link className="ro-pill" to="/book-event" style={{ marginTop: 30 }}>
              Book your event
            </Link>
          </div>
          <Guest className="ro-faq-intro__host" />
        </div>
      </section>

      <section className="ro-section">
        <div className="ro-container">
          <h2 className="ro-events-title">
            Two ways to <span className="ro-outline">celebrate.</span>
          </h2>
          <div className="ro-kinds">
            {eventKinds.map((k) => (
              <Link key={k.slug} to={`/events/${k.slug}`} className="ro-kind">
                <img src={k.cover} alt={k.coverAlt} loading="lazy" />
                <h3 className="ro-italic">{k.name}</h3>
                <p>{k.intro}</p>
                <span className="ro-kind__more">
                  {k.occasions.length} occasions →
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="ro-section ro-tinted ro-events-gallery">
        <div className="ro-container">
          <div className="ro-events-gallery__head">
            <h2>
              Memories are <span className="ro-outline">made here.</span>
            </h2>
            <SpeechBubble onClick={() => openModal("gallery", { photos: eventGallery, index: 0, title: "Celebrations" })}>
              Open the
              <br />
              event gallery
            </SpeechBubble>
          </div>
          <div className="ro-mosaic">
            {eventGallery.slice(0, 6).map((p, i) => (
              <button key={p.src} type="button" onClick={() => openModal("gallery", { photos: eventGallery, index: i, title: "Celebrations" })} aria-label={`Open photo: ${p.alt}`}>
                <img src={p.src} alt="" loading="lazy" />
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="ro-availability">
        <div className="ro-container">
          <h2>
            <span className="ro-outline ro-outline--light">Plan your</span> <strong className="ro-italic">celebration</strong>
          </h2>
          <p>Tell us the date, the occasion and the guest count. The team confirms by phone or email.</p>
          <div className="ro-availability__actions">
            <Link className="ro-pill" to="/book-event">
              Book an event
            </Link>
            <Link className="ro-pill" to="/find-us">
              Find us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
